module.exports = __webpack_public_path__ + "img/access-denied.7b739cc6.svg";